import React from 'react';

export const RectangleArrow = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="30" height="28.5852" transform="translate(0 0.666016)" fill="#242424" />
    <rect y="0.666016" width="30" height="28.5852" fill="#242424" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2929 21.3493C12.6834 21.7214 13.3166 21.7214 13.7071 21.3493L19.7071 15.6322C19.8946 15.4535 20 15.2112 20 14.9585C20 14.7058 19.8946 14.4634 19.7071 14.2847L13.7071 8.56765C13.3166 8.19555 12.6834 8.19555 12.2929 8.56765C11.9024 8.93976 11.9024 9.54307 12.2929 9.91518L17.5858 14.9585L12.2929 20.0017C11.9024 20.3739 11.9024 20.9772 12.2929 21.3493Z"
      fill="white"
    />
  </svg>
);
